import api from '@/api/api';

export default {
    getByEmpresa: (empresa_id) => {
        return api.get(`/v1/projetos/${empresa_id}/macro-etapas-globais`);
    },
    create: (empresa_id, payload) => {
        return api.post(`/v1/projetos/${empresa_id}/macro-etapas-globais`, payload);
    },
    update: (empresa_id, id, payload) => {
        return api.put(`/v1/projetos/${empresa_id}/macro-etapas-globais/${id}`, payload);
    },
    delete: (empresa_id, id) => {
        return api.delete(`/v1/projetos/${empresa_id}/macro-etapas-globais/${id}`);
    }
}
